<template>
<div class="main-in">
    <div class="container" v-cloak>
        <div is='titlebox' :nav='nav'></div>
        <div class="content">
            <!-- 组织机构 -->
            <!-- <div class="left-corner f-row-l">
                <div class="bg-title1 f-row-c bbact">组织机构</div>
            </div> -->
            <div class="min-h f-row-l align-start wrap">
                <div class="box-l">
                    <div class="sub">机构名称：{{info.orgName}}</div>
                    <div class="sub">办公主任：{{info.officeDirector}}</div>
                    <div class="sub">办公电话：{{info.officePhone}}</div>
                </div>
                <div class="box-r">
                    <div class="title">简介：</div>
                    <div class="cont" v-html="info.officeBrief"></div>
                </div>
                    
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {list} from '@/axios/api'
export default {
    data() {
        return {
            nav:[
                {
                    label:'机构设置',
                    path:'/Organization',
                    type:0
                },
                {
                    label:'机构详情',
                    path:'/Organization/see',
                    id:0
                }
            ],
            info:{}
        }
    },
    created(){
        this.getInfo()
    },
    mounted(){
        
    },
    methods: {
        getInfo() {
            this.$get('/web/orgConfig/queryById?id='+this.$route.query.id).then(res=>{ 
                if(res.success){ 
                    this.info=res.result
                }
            })
        },
    },
}
</script>

<style lang="scss">
.content{
    padding: 22px 50px;
}
.min-h {
    width: 100%;
    position: relative;
    color: #333333;
    .title {
        font-weight: bold;
        color: #000000;
        margin-bottom:10px;
    }
    .sub{
        
        margin-bottom: 10px;
    }
    .cont{
        margin-top: 20px;
        color: #666666;
        text-align: left;
    }
    
    
}
.box-l{
    padding: 10px;
    width: 210px;
    height: auto;
    background: #AA0F14;
    color: #ffffff;
}
.box-r {
    width: calc(100% - 210px);
    padding: 10px;
    padding-left:30px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    
}
</style>